module.exports = __webpack_public_path__ + "img/17.d6b57934.jpg";